import React from "react";

const FourCardsView = ({
  data = [],
//   columns = 3,
  gap = "gap-2",
  rounded = "rounded-[16px]",
  shadow = "7px 7px 9.5px 0px #0000000D",
  showIcon = true,
  fontFamily = "font-[Lato]",
  labelKey = "label",
  valueKey = "value",
  unitKey = "unit",
  iconKey = "icon",
  colorKey = "tabColor",
  t,
}) => {
  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 ${gap} ${fontFamily}`}>
      {data.map((item, index) => {
        const label = item[labelKey];
        const value = item[valueKey];
        const unit = item[unitKey];
        const icon = item[iconKey];
        const tabColor = item[colorKey];

        return (
          <div
            key={index}
            className={`py-5 px-3 ${rounded} bg-white border border-[#E6E6E6] grid md:grid-cols-2 lg:grid-cols-1 items-center gap-2 justify-center`}
            style={{
              boxShadow: shadow,
            }}
          >
            {showIcon && (
              <div className="w-full flex justify-center">
                <div
                  className="rounded-full w-[57px] h-[57px] flex items-center justify-center"
                  style={{ backgroundColor: tabColor }}
                >
                  {icon}
                </div>
              </div>
            )}

            <div>
              <p className="text-[10px] md:text-[12px] font-[500] text-[#6C6A6ACC] text-center md:text-start lg:text-center">
                {t
                  ? t(`dietPlanDashboard.mealListing.mealNutrientsData.${label}`)
                  : label}
              </p>
              <p className="text-[10px] md:text-[16px] font-[500] text-[#6C6A6A] text-center md:text-start lg:text-center">
                {!value
                  ? `0 ${unit || ""}`
                  : value.toString().trim().toLowerCase().endsWith(unit?.toLowerCase() || "")
                  ? value
                  : `${value} ${unit || ""}`}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FourCardsView;
